import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import Popup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const Wrapper = styled(Popup)`
    padding: 40px;
    width: calc(100% - 10px) !important;
    max-width: 896px !important;
    @media (max-width: 1024px) {
        max-width: 660px !important;
    }
    @media (max-width: 700px) {
        max-width: 430px !important;
    }
    @media (max-width: 410px) {
        padding: 40px 20px;
    }
`;

export const Title = styled.div`
    ${FONTS.H2};
    color: ${COLORS.black};
    margin-bottom: 12px;
    @media (max-width: 700px) {
        ${FONTS.H3};
    }
`;

export const Subtitle = styled.p`
    ${FONTS.S};
    color: ${COLORS.black};
    margin-bottom: 40px;
    @media (max-width: 700px) {
        ${FONTS.S};
    }
`;

export const Message = styled.div`
    display: block;
    width: 100%;
    ${FONTS.XXL};
    color: ${p => p.error ? COLORS.red : 'auto'};
    margin-top: 15px 0;
`;

export const Loader = styled(Throbber)`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    transform: translate(0, 0);
    width: 120px;
`;
